module.exports = __webpack_public_path__ + "static/media/filled-cloud.e79a2f41.svg";